import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import BillresPage from './BillerList.page';
import { getListBiller } from '../../redux/actions/billers';
import { resetFilter } from '../../../../redux/actions/newFilter';

const mapStateToProps = state => ({
  listBiller: state.allbiller.listBiller,
  billerFilter: state.allbiller.billerFilter,
  loading: state.allbiller.loading,
  filterValue: state.newFilter.filterValue,
  formControlShow: state.newFilter.formControlShow,
});

const mapDispatchToProps = { getListBiller, resetFilter };

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(BillresPage));
